import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import useStyles from './styles';
import { inputDataCustom } from '../../../../../utils/custom_prop_types/customPropTypes';

export default function AddButton({
  fetchProductsBySection,
  nestedProduct,
  inputData,
  handleAddAccessory,
  addedProducts,
  setAddedProducts,
  isRootNode,
}) {
  const classes = useStyles();

  const handleAddButtonClick = (event, associationNumber) => {
    handleAddAccessory(event);
    fetchProductsBySection({
      section: 'accessory',
      accessoryGroup: associationNumber,
      color: inputData.color,
      isRootNode,
    });
    setAddedProducts([...addedProducts, `${nestedProduct['@id']}${nestedProduct.association}`]);
  };

  return (
    <Button
      disabled={addedProducts.includes(`${nestedProduct['@id']}${nestedProduct.association}`)}
      className={classes.addButton}
      variant="contained"
      color="secondary"
      text="ADD"
      onClick={(event) => handleAddButtonClick(event,
        nestedProduct.productGroup.number)}
      data-iri={nestedProduct['@id']}
      data-description={nestedProduct.description}
      data-value={nestedProduct.association}
    >
      ADD
    </Button>
  );
}

AddButton.propTypes = {
  fetchProductsBySection: PropTypes.func.isRequired,
  nestedProduct: PropTypes.objectOf(PropTypes.any).isRequired,
  inputData: inputDataCustom.isRequired,
  handleAddAccessory: PropTypes.func.isRequired,
  addedProducts: PropTypes.arrayOf(PropTypes.string).isRequired,
  setAddedProducts: PropTypes.func.isRequired,
  isRootNode: PropTypes.bool.isRequired,
};
